export default __webpack_public_path__ + "static/media/chevron-left.11035533.svg";